module.exports = __webpack_public_path__ + "static/media/adela-pris.2b41087c.jpg";